import type { SocialLink } from "@/features/profile/types/social-links";

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: "https://assets.binx.com/images/link-icons/linkedin.webp",
    title: "LinkedIn",
    href: "https://www.linkedin.com/in/binx",
  },
  {
    icon: "https://assets.binx.com/images/link-icons/github.webp",
    title: "GitHub",
    href: "https://github.com/binx",
  },
  {
    icon: "https://assets.binx.com/images/link-icons/dailydev.webp",
    title: "Daily.dev",
    href: "https://app.daily.dev/binx",
  },
  {
    icon: "https://assets.binx.com/images/link-icons/x.webp",
    title: "X (formerly Twitter)",
    href: "https://x.com/binx",
  },
  {
    icon: "https://assets.binx.com/images/link-icons/zalo.webp",
    title: "Zalo",
    href: "https://zalo.me/binx",
  },
  {
    icon: "https://assets.binx.com/images/link-icons/youtube.webp",
    title: "YouTube",
    href: "https://youtube.com/@binx",
  },
];
